/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCircleNumber4 = createReactComponent("circle-number-4", "IconCircleNumber4", [
  ["path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-0" }],
  ["path", { d: "M10 8v3a1 1 0 0 0 1 1h3", key: "svg-1" }],
  ["path", { d: "M14 8v8", key: "svg-2" }]
]);

export { IconCircleNumber4 as default };
//# sourceMappingURL=IconCircleNumber4.js.map
